import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, module }) {
  const { user, loading, hasPerm } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (module && !hasPerm(module)) {
    return (
      <div className="p-12 text-center">
        <h2 className="text-2xl font-display font-semibold text-slate-900">Access Denied</h2>
        <p className="mt-2 text-sm text-slate-500">You don't have permission to view this module.</p>
      </div>
    );
  }
  return children;
}
